(function (scope) {
  'use strict';
  const windows = {
    thanksgiving: { start: '2026-11-21', end: '2026-11-25', label: 'Thanksgiving 2026', availableDates: 'November 21–25, 2026', closedDates: [] },
    christmas: { start: '2026-12-17', end: '2026-12-24', label: 'Christmas 2026', availableDates: 'December 17–24, 2026', closedDates: [] }
  };
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  function validDate(iso, season, today, closedDates = []) {
    const window = windows[season];
    if (!window || !/^\d{4}-\d{2}-\d{2}$/.test(iso || '')) return false;
    const date = new Date(iso + 'T12:00:00Z');
    return !Number.isNaN(date.getTime()) && date.toISOString().slice(0, 10) === iso &&
      iso >= window.start && iso <= window.end && (!today || iso >= today) && !window.closedDates.includes(iso) && !closedDates.includes(iso);
  }
  function friendlyDate(iso) {
    return new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }).format(new Date(iso + 'T12:00:00Z'));
  }
  function pickupHours(iso) {
    const day = new Date(iso + 'T12:00:00Z').getUTCDay();
    return day === 0 ? '10 a.m.–5 p.m.' : '11 a.m.–6 p.m.';
  }
  function denverToday() {
    return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Denver', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  }
  function dateMessage(season) {
    return 'Choose a pickup date from ' + windows[season].availableDates + ' only.';
  }
  const api = { windows, validDate, friendlyDate, money, denverToday, pickupHours, dateMessage };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  scope.LBHoliday = api;
  if (typeof document === 'undefined') return;

  function dateBounds(date, season) {
    date.min = [windows[season].start, denverToday()].sort().at(-1);
    date.max = windows[season].end;
    if (date.tagName === 'SELECT') {
      for (const option of date.options) if (option.value) option.disabled = !validDate(option.value, season, denverToday());
    }
  }

  function initShop(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const season = root.dataset.holidayShop;
    const date = root.querySelector('[data-holiday-shop-date]');
    const status = root.querySelector('[data-holiday-shop-status]');
    dateBounds(date, season);
    function remember() {
      const valid = validDate(date.value, season, denverToday());
      date.setCustomValidity(date.value && !valid ? dateMessage(season) : '');
      status.textContent = valid ? 'Pickup ' + friendlyDate(date.value) + '. Review your date on each product and in your cart.' : dateMessage(season) + ' You can also choose on a product page.';
      try { sessionStorage.setItem('lb-pickup-' + season, valid ? date.value : ''); } catch (_) { /* Optional convenience only. */ }
      root.querySelectorAll('a[href*="/products/"]').forEach(link => {
        const url = new URL(link.href);
        url.searchParams.set('holiday', season);
        if (valid) url.searchParams.set('pickup_date', date.value); else url.searchParams.delete('pickup_date');
        link.href = url.href;
      });
    }
    try { date.value = sessionStorage.getItem('lb-pickup-' + season) || ''; } catch (_) { /* Optional convenience only. */ }
    if (!validDate(date.value, season, denverToday())) date.value = '';
    date.addEventListener('change', remember);
    date.addEventListener('input', remember);
    remember();
  }
  function initProduct(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const meta = JSON.parse(root.querySelector('[data-holiday-meta]').textContent || 'null');
    const variants = JSON.parse(root.querySelector('[data-holiday-variants]').textContent);
    const form = root.querySelector('form');
    const submit = root.querySelector('[data-holiday-submit]');
    if (!meta || !meta.key) { submit.disabled = true; return; }
    const season = root.querySelector('[data-holiday-season]');
    const date = root.querySelector('[data-holiday-date]');
    const variant = root.querySelector('[data-holiday-variant]');
    const pricing = root.querySelector('[data-holiday-pricing]');
    const quantity = form.querySelector('[name="quantity"]');
    const extras = scope.LBHolidayExtras?.init(root);
    function selected() {
      const selectedVariant = variants.find(v => String(v.id) === variant.value);
      return { shopify: selectedVariant, retail: meta.variants.find(v => v.title === selectedVariant?.title) };
    }
    function update() {
      const window = windows[season.value];
      dateBounds(date, season.value);
      root.querySelector('[data-holiday-window]').textContent = 'Available pickup dates: ' + window.availableDates + '.';
      if (!validDate(date.value, season.value, denverToday())) date.value = '';
      root.querySelector('[data-holiday-property]').value = window.label;
      const { shopify, retail } = selected();
      if (!shopify || !retail) { submit.disabled = true; return; }
      submit.disabled = meta.held || !shopify.available || shopify.price !== retail.onlineCents;
      if (shopify.price !== retail.onlineCents) root.querySelector('[data-holiday-status]').textContent = 'Pricing is being updated. Please call 303-225-3199 to order.';
      if (meta.components) {
        // All numbers here are per bundle. Quantity is shown explicitly to avoid implying a single deposit covers several bundles.
        const qty = Math.max(1, Number(quantity.value) || 1);
        pricing.innerHTML = `<p class="holiday-price__total">Full bundle total <strong>${money(retail.priceCents * qty)}</strong></p><p>Purchased separately ${money(retail.compareAtCents * qty)}. <strong>Save ${money((retail.compareAtCents - retail.priceCents) * qty)}.</strong></p><p>Pay ${money(shopify.price * qty)} deposit today. <strong>${money((retail.priceCents - shopify.price) * qty)} due at pickup.</strong></p>`;
        for (const [selector, value] of [
          ['[data-holiday-full-total]', money(retail.priceCents) + ' per bundle'],
          ['[data-holiday-balance]', money(retail.priceCents - shopify.price) + ' per bundle'],
          ['[data-holiday-preparation]', shopify.title === 'Default Title' ? 'As listed in bundle' : shopify.title]
        ]) { const input = root.querySelector(selector); input.disabled = false; input.value = value; }
      } else if (meta.weighedPreparations) {
        pricing.innerHTML = `<p class="holiday-price__total">${money(retail.priceCents)} per lb · ${shopify.title}</p><p><strong>${money(shopify.price)} deposit online.</strong> Your deposit is credited toward the final weighed total. The remaining balance is due at pickup.</p><p>Raw ${money(meta.variants[0].priceCents)}/lb; smoked ${money(meta.variants[1].priceCents)}/lb. Smoking adds $5/lb. Both use the raw weight, before cooking.</p>`;
        const preparation = root.querySelector('[data-holiday-preparation]');
        preparation.disabled = false;
        preparation.value = shopify.title;
        root.querySelector('[data-holiday-meat-price]').value = money(retail.priceCents) + ' per lb of raw weight';
        const weight = Number(root.querySelector('[data-holiday-weight]').value);
        const estimateInput = root.querySelector('[data-holiday-estimate-property]');
        const hasWeight = Number.isFinite(weight) && weight >= 1 && weight <= 100 && Number.isInteger(weight * 2);
        estimateInput.disabled = !hasWeight;
        const estimate = Math.round(weight * retail.priceCents);
        estimateInput.value = hasWeight ? money(estimate) + ' per reservation before tax; actual raw weight determines final total' : '';
        root.querySelector('[data-holiday-weight-estimate]').textContent = hasWeight ? 'Estimated total per reservation: ' + money(estimate) + '. ' + (estimate >= shopify.price ? 'Estimated balance after deposit: ' + money(estimate - shopify.price) + '.' : 'Your deposit is reconciled against the final weighed total.') + ' Before tax; actual raw weight determines the final price.' : 'Enter your requested raw weight to see an estimate.';
      }
      extras?.update({retail, shopify, quantity: Math.max(1, Number(quantity.value) || 1)});
    }
    function syncDate() {
      date.setCustomValidity('');
      const valid = validDate(date.value, season.value, denverToday());
      if (!valid) date.setCustomValidity(dateMessage(season.value));
      const error = root.querySelector('[data-holiday-date-error]');
      if (error) error.textContent = valid ? '' : dateMessage(season.value);
      root.querySelector('[data-holiday-friendly]').value = valid ? friendlyDate(date.value) : '';
      root.querySelector('[data-holiday-iso]').value = valid ? date.value : '';
      root.querySelector('[data-holiday-hours]').value = valid ? pickupHours(date.value) : '';
      if (valid) {
        try { sessionStorage.setItem('lb-pickup-' + season.value, date.value); } catch (_) { /* Storage may be disabled. */ }
      }
      return valid;
    }
    season.addEventListener('change', () => { date.setCustomValidity(''); update(); syncDate(); });
    variant.addEventListener('change', update);
    quantity.addEventListener('input', update);
    root.querySelector('[data-holiday-weight]')?.addEventListener('input', update);
    date.addEventListener('change', syncDate);
    date.addEventListener('input', syncDate);
    date.addEventListener('invalid', syncDate);
    form.addEventListener('submit', event => {
      update();
      if (!syncDate() || submit.disabled) { event.preventDefault(); form.reportValidity(); return; }
      if (extras?.hasSelected()) {event.preventDefault(); if (form.reportValidity()) extras.submit();}
    });
    const params = new URLSearchParams(location.search);
    if (meta.holiday === 'both' && [...season.options].some(option => option.value === params.get('holiday') && !option.disabled)) season.value = params.get('holiday');
    try { date.value = sessionStorage.getItem('lb-pickup-' + season.value) || ''; } catch (_) { /* Optional convenience only. */ }
    if (validDate(params.get('pickup_date'), season.value, denverToday())) date.value = params.get('pickup_date');
    update();
    if (date.value) syncDate();
  }
  function init() {
    document.querySelectorAll('[data-holiday-shop]').forEach(initShop);
    document.querySelectorAll('[data-holiday-product]').forEach(initProduct);
  }
  init();
  document.addEventListener('shopify:section:load', init);
})(typeof window === 'undefined' ? globalThis : window);
